export enum TransportTypes {
  LTL = 1,
  FTL = 2,
  Rail = 3,
  JitKanban = 4,
}

export enum TransportTypesStringValue {
  LTL = "LTL",
  FTL = "FTL",
  Rail = "Rail",
  JitKanban = "Jit Kanban",
}

export const transportTypeAsString = new Map([
  [TransportTypes.LTL, "LTL"],
  [TransportTypes.FTL, "FTL"],
  [TransportTypes.Rail, "Rail"],
  [TransportTypes.JitKanban, "JitKanban"],
]);
